/**
 * Noor Qalb — Whop checkout page (embedded on storefront domain)
 */
(function () {
  var root = document.getElementById('nq-whop-checkout');
  if (!root) return;

  var apiBase = root.getAttribute('data-api') || '';
  var mount = document.getElementById('nq-whop-mount');
  var statusEl = document.getElementById('nq-whop-status');
  var summaryEl = document.getElementById('nq-whop-summary');

  function setStatus(msg, isError) {
    if (!statusEl) return;
    statusEl.textContent = msg || '';
    statusEl.hidden = !msg;
    statusEl.classList.toggle('is-error', !!isError);
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, {
        style: 'currency',
        currency: (currency || 'GBP').toUpperCase(),
      }).format((Number(cents) || 0) / 100);
    } catch (e) {
      return ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function renderSummary(cart) {
    if (!summaryEl || !cart) return;
    var html = '<ul class="nq-whop__lines">';
    (cart.items || []).forEach(function (item) {
      html +=
        '<li><span>' +
        (item.quantity || 1) +
        '× ' +
        (item.product_title || item.title || 'Item') +
        '</span><span>' +
        money(item.final_line_price || item.line_price, cart.currency) +
        '</span></li>';
    });
    html +=
      '</ul><div class="nq-whop__total"><span>Total</span><strong>' +
      money(cart.total_price, cart.currency) +
      '</strong></div>';
    summaryEl.innerHTML = html;
  }

  function mountWhop(session) {
    if (!mount) return;
    mount.innerHTML = '';

    var returnUrl =
      root.getAttribute('data-return') ||
      window.location.origin + '/thanks';

    // Prefer embed; if Whop only gives a purchase URL, use that
    if (!session.planId && session.purchaseUrl) {
      window.location.href = session.purchaseUrl;
      return;
    }

    var el = document.createElement('div');
    if (session.planId) el.setAttribute('data-whop-checkout-plan-id', session.planId);
    if (session.sessionId) el.setAttribute('data-whop-checkout-session', session.sessionId);
    el.setAttribute('data-whop-checkout-return-url', returnUrl);
    el.setAttribute('data-whop-checkout-theme', 'light');
    el.setAttribute('data-whop-checkout-theme-accent-color', '#0f5c4c');
    el.setAttribute('data-whop-checkout-collect-shipping', 'true');
    el.setAttribute('data-whop-checkout-skip-redirect', 'false');
    mount.appendChild(el);

    // Fallback: if embed doesn't hydrate shortly, send to hosted Whop checkout
    setTimeout(function () {
      var hasFrame = mount.querySelector('iframe');
      if (!hasFrame && session.purchaseUrl) {
        window.location.href = session.purchaseUrl;
      }
    }, 4000);
  }

  async function start() {
    setStatus('Loading your cart…');
    var cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
    var cart = await cartRes.json();
    if (!cart || !cart.item_count) {
      setStatus('Your cart is empty. Add something before checkout.', true);
      if (summaryEl) summaryEl.innerHTML = '';
      return;
    }
    renderSummary(cart);
    setStatus('Preparing secure checkout…');

    var res = await fetch(apiBase.replace(/\/$/, '') + '/api/create-checkout', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(cart),
    });
    var data = await res.json().catch(function () {
      return {};
    });
    if (!res.ok || data.error) {
      setStatus(data.error || 'Could not start checkout. Try again.', true);
      return;
    }
    setStatus('');
    mountWhop(data);
  }

  start().catch(function (err) {
    setStatus(String(err && err.message ? err.message : err), true);
  });
})();
